import { useContext, useEffect, useState } from 'react'
import { TextField } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { AdminVoterAuthService } from '@nv/services'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './AdminEnterName.module.scss'

const initialValues = {
  name: '',
}

export const AdminEnterName = ({}) => {
  const { t } = useTranslation()
  const [updateErr, setUpdateErr] = useState(false)
  const [loading, setLoading] = useState(false)
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const schema = Yup.object().shape({
    name: Yup.string().required(t('Name is required')),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true)
      const resp = await AdminVoterAuthService.saveName(values.name)
      setLoading(false)
      if (resp?.success) {
        sessionStorage.setItem('name', values.name)
        onClose()
      } else {
        alert('Something went wrong, please try again.')
      }
    },
  })

  useEffect(() => {
    setHeaderLabel(t('Enter your name to continue'))
    setBtns([{ text: t('buttons.ok'), onClick: formik.submitForm }])
  }, [])
  return (
    <div className={styles['container']}>
      <TextField
        formik={formik}
        type='name'
        field='name'
        placeholder={t('form.labels.name')}
        label={t('form.labels.name')}
        isRequired={true}
        autocomplete='off'
      />
    </div>
  )
}
